import { render } from "./custom_field.vue?vue&type=template&id=b73c0f42"
import script from "./custom_field.vue?vue&type=script&lang=js"
export * from "./custom_field.vue?vue&type=script&lang=js"

import exportComponent from "/app/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/custom_field.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b73c0f42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b73c0f42', __exports__)) {
    api.reload('b73c0f42', __exports__)
  }
  
  module.hot.accept("./custom_field.vue?vue&type=template&id=b73c0f42", () => {
    api.rerender('b73c0f42', render)
  })

}


export default __exports__